export const environment = {
  production: false,
  url_api: ''
};
